import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
export function LanguageToggle() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return (
    // Hide on mobile (md:flex), show on desktop
    <div className="hidden md:flex fixed bottom-8 right-8 z-50 items-center gap-2" data-id="element-195">
      <button onClick={() => setLanguage('fr')} className={`px-3 py-1 font-cyber text-xs font-bold tracking-widest transition-all border ${language === 'fr' ? 'border-cyan text-cyan bg-cyan/10 box-glow-cyan' : 'border-white/20 text-gray-500 hover:text-white'}`} data-id="element-196">
        FR
      </button>
      <div className="w-px h-4 bg-white/20" data-id="element-197" />
      <button onClick={() => setLanguage('en')} className={`px-3 py-1 font-cyber text-xs font-bold tracking-widest transition-all border ${language === 'en' ? 'border-cyan text-cyan bg-cyan/10 box-glow-cyan' : 'border-white/20 text-gray-500 hover:text-white'}`} data-id="element-198">
        EN
      </button>
    </div>
  );
}